import React from 'react';
import LoadingBars from './LoadingBars';
import { Vertical } from 'gls';
import { style } from 'typestyle';

export default function LoadingScreen({ text = "loading..." }: { text?: string }) {
  return (
    <main className="u-flex-center">
      <Vertical sizing="stretch" spacing={30} className={style({ marginTop: "30px" })}>
        <LoadingBars />
        <span>{text}</span>
      </Vertical>
    </main>
  );
}
